import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import TextInput from "components/inputs/text"
import CheckboxInput from "components/inputs/checkbox"
import { RowAddRemove } from "components/table/carousel/row-add-remove-by-reference"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { handleReferences } from "data/lib/handle-references"
import notificationService from "data/notification"

type Row = {
  name: string
  affectsOccupancy: boolean
  i: number
}

const LeaseTypes = (props: {data: [any], persist: Function, propertyid: number|null, hide: Function}) => {
  const emptyRecord: Row = {
    name: "",
    affectsOccupancy: true,
    i: 0
  }

  const [data, setData] = useState<[Row]>(_.map(props.data, (item, i) => { return {...item, i }}) || [{...emptyRecord, i: 0}])

  useEffect(() => {
    setData(props.data)
  }, [props.data])

  function updateVal(index: number, field:string, val:any):void {
    const newData = _.cloneDeep(data)
    const item = _.cloneDeep(newData[index])
    _.set(item, field, val)
    newData.splice(index, 1, item)
    setData(newData)
    props.persist("leasetypedetail", _.map(newData, (i) => { return {name: i.name, affectsOccupancy: i.affectsOccupancy} }))
  }

  async function updateItems(items: [any]): Promise<void> {
    if(_.filter(items, (i) => i.name === "").length > 1) {
      if(items.length > data.length) {
        items = _.map(data, (d, i) => { return {...d, i} })
        notificationService.notify({
          type: "warn",
          message: "You can not add duplicate blank rows",
          dismiss: 2000
        })
      }
    }

    const update = () => {
      const newItems = _.map(_.cloneDeep(items), (i) => { return {name: i.name, affectsOccupancy: i.affectsOccupancy} })
      setData(items)
      props.persist("leasetypedetail", newItems)
    }

    if(items.length < data.length) {
      const removed = _.differenceBy(data, items, 'name')
      const refreshFn = () => {}
      if (!(await handleReferences('property', _.get(props, "propertyid"), {deleteFn: update, refreshFn, special: 'leasetypedetail', specialId: removed[0].name, key: 'name'}))) {
        props.hide()
      } else update()
    } else update()
  }

  return (
    <div className="lease-types-container">
      <div className="labels">
        <label>Name</label>
        <label>Affects Occupancy</label>
      </div>
      { data.map((row: Row, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row" key={`${row.name}-${i}`}>
            <div>
              <TextInput
                className="automated"
                value={_.get(row, "name")}
                persist={(val) => updateVal(i, "name", val)}/>
            </div>
            <div>
              <CheckboxInput
                className="automated"
                field="affectsOccupancy"
                value={_.get(row, "affectsOccupancy")}
                persist={(field:string, val:boolean) => updateVal(i, field, val)}/>
            </div>
            <RowAddRemove emptyRecord={{...emptyRecord, i: i+1}} persist={updateItems} row={row} items={data} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default LeaseTypes
